export const itemConstants = {
  GET_SINGLE_REQUEST: "ITEM_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "ITEM_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "ITEM_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "ITEM_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "ITEM_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "ITEM_GET_ALL_FAILURE",

  ADD_REQUEST: "ITEM_ADD_REQUEST",
  ADD_SUCCESS: "ITEM_ADD_SUCCESS",
  ADD_FAILURE: "ITEM_ADD_FAILURE",

  UPDATE_REQUEST: "ITEM_UPDATE_REQUEST",
  UPDATE_SUCCESS: "ITEM_UPDATE_SUCCESS",
  UPDATE_FAILURE: "ITEM_UPDATE_FAILURE",

  DELETE_REQUEST: "ITEM_DELETE_REQUEST",
  DELETE_SUCCESS: "ITEM_DELETE_SUCCESS",
  DELETE_FAILURE: "ITEM_DELETE_FAILURE",

  CLEAR: "ITEM_CLEAR",
};
